module.exports = __webpack_public_path__ + "img/img28.55da459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img28.png
// module id = 205
// module chunks = 0